import { memo } from 'react';
import { OrderProductsTable } from 'features/Orders';

const DetailProductsPanel = ({ row }: { row: any }) => {
  return <OrderProductsTable orderProducts={row.original.orderProducts} orderId={row.original.orderId} isActionsVisible={false} />;
};

export default memo(DetailProductsPanel);
